<!--
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-02-22 14:37:43
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2024-01-08 09:54:34
-->
<template>
	<div class="main-content-padding">
		<Panel :contentPaddingTop="12" class="orderDetails content-box">
			<platformTab @change="platformClick" :showAll="false" :platformId="platformId"></platformTab>
			<div v-show="showPlatformContent">
				<SubTabs v-model="tabName" @tab-click="tabClick" :list="tableArr">
					<template slot-scope="{ item }">
						<span>{{ item.label }}</span>
					</template>
				</SubTabs>
				<Tip :content="tipContent" :type="isTrialAccount ? 'warning' : 'primary'" class="mt-12"></Tip>
				<search ref="search" @onSubmit="onSubmit" :tabName="tabName" :platformId="platformId" @setParamsTextArr="setParamsTextArr"></search>
			</div>
		</Panel>
		<Panel :contentPaddingTop="0" v-show="showPlatformContent">
			<tab :tabName="tabName" ref="tab" :platformId="platformId"></tab>
		</Panel>
	</div>
</template>
<script>
import { mapGetters } from 'vuex';
import tab from './components/tab.vue';
import search from './components/search.vue';
import { platformMixin } from '@rd/rd-ui';
import SubTabs from '@/components/ui/subTabs/index.vue';
export default {
	name: 'orderDetails',
	components: {
		tab,
		search,
		SubTabs,
	},
	mixins: [platformMixin],
	data() {
		return {
			tabName: '0',
			platformId: '',
		};
	},
	computed: {
		...mapGetters(['defaultPlatform', 'isTrialAccount']),
		tableArr() {
			return [
				{ label: '服务费收入', name: '0' },
				{ label: '服务费支出', name: '1' },
			];
		},
		drName() {
			return dataMap.drRoleType.name;
		},
		zsName() {
			return dataMap.zsRoleType.name;
		},
		tipContent() {
			return this.isTrialAccount
				? '您当前为试用账号，最早的订单付款时间为【授权时间+7天】，升级到正式账户后将自动更新最近 90天的订单。'
				: `温馨提示：历史订单数据，暂不支持自动业绩统计；未归属业绩的订单，请在【${this.drName}】或【${this.zsName}】条件中，筛选【未归属】进行查看、手动分配订单归属`;
		},
	},
	methods: {
		platformClick(val) {
			this.platformId = val;

			if (!this.showPlatformContent) return;
			this.tabName = '0';
			this.$nextTick(() => this.$refs.search.onClear(1));
		},
		tabClick(val) {
			this.tabName = val;
			this.$nextTick(() => this.$refs.search.onClear(1));
		},
		onSubmit(val) {
			this.$refs['tab'].onSubmit(val);
		},
		setParamsTextArr(val) {
			this.$refs['tab'].setParamsTextArr(val);
		},
	},
};
</script>
<style scss="less" scoped></style>
